module.exports = __webpack_public_path__ + "static/media/gh-painting-hero-TEMP.ca89e6f5.jpg";